import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

import * as S from '../PandaDocAnalytics.styled';
import { DocumentsTable } from '../DocumentsTable';

interface IDocumentsTabProps {
  /** Course filter shared with the analytics tabs (`all` → no filter). */
  course: string;
  /** ISO `YYYY-MM-DD` date-created bounds; `null` means unbounded. */
  dateFrom: string | null;
  dateTo: string | null;
}

/** Standalone documents tab — kept separate for the planned student workflow. */
export const DocumentsTab = memo(
  ({ course, dateFrom, dateTo }: IDocumentsTabProps) => {
    const { t } = useTranslation();

    return (
      <>
        <S.SectionTitle>
          {t('pages.pandadocAnalytics.table.listTitle')}
        </S.SectionTitle>
        <DocumentsTable course={course} dateFrom={dateFrom} dateTo={dateTo} />
      </>
    );
  },
);
